module.exports = __webpack_public_path__ + "img/winners-list_ar.b8b58acd.png";